export const INQUIRY_TYPE_OFFER = 'offer';
export const INQUIRY_TYPE_PRODUCT_SAMPLE = 'product-sample';
